import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  ManageMediaList,
  GetMediaList,
  DeleteMediaList,
  GetMediaTypes,
  EditMediaList,
} from "./actions";

const MediaList = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const Schema = Yup.object().shape({
    title: Yup.string().trim().required("required"),
    ref_link: Yup.string().trim().required("required"),
    // vid: Yup.string().trim().required("required"),
    short_desc: Yup.string().trim().required("required"),
    full_desc: Yup.string().trim().required("required"),
  });

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetMediaList({
        page,
        rowsPerPage,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setTotalData(data?.count);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    dispatch(
      GetMediaTypes({
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setMediaTypes(data?.data);
            if (array.length == 0) {
              setarray([
                {
                  failed: "id",
                  type: inputType.text,
                  title: "id",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { display: "none" },
                },
                {
                  failed: "title",
                  type: inputType.text,
                  title: "Title",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "ref_link",
                  type: inputType.text,
                  title: "Reference Link",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "vid",
                  type: inputType.image,
                  title: "Video",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "date",
                  type: inputType.date,
                  title: "Date",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "short_desc",
                  type: inputType.text,
                  title: "Short Description",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "full_desc",
                  type: inputType.text,
                  title: "Full Description",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
                {
                  failed: "media_type_id",
                  type: inputType.dropdown,
                  title: "Media Type",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                  datadropdown: data?.data,
                  faileddropdown: {
                    name: "type_name",
                    value: "id",
                  },
                },
                {
                  failed: "image",
                  type: inputType.image,
                  title: "Image",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
              ]);
            }
          } else {
            setMediaTypes([]);
          }
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.image, name: "image" },
    { type: columntype.text, name: "title" },
    { type: columntype.image, name: "vid" },
    { type: columntype.text, name: "date" },
    { type: columntype.vid, name: "ref_link" },
    { type: columntype.text, name: "short_desc" },
    { type: columntype.text, name: "full_desc" },
    { type: columntype.text, name: "media_type_id" },
    { type: columntype.switch, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      withSort: false,
    },
    {
      id: "vid",
      numeric: false,
      disablePadding: false,
      label: "Video",
      withSort: true,
    },

    {
      id: "date",
      numeric: false,
      disablePadding: false,
      label: "Date",
      withSort: true,
    },
    {
      id: "ref_link",
      numeric: false,
      disablePadding: false,
      label: "Reference Link",
      withSort: false,
    },

    {
      id: "short_desc",
      numeric: false,
      disablePadding: false,
      label: "Short Description",
      withSort: true,
    },
    {
      id: "full_desc",
      numeric: false,
      disablePadding: false,
      label: "Full Description",
      withSort: true,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is active",
      withSort: true,
    },
    (dataPrivileges["17"]?.access_edit == 1 ||
      dataPrivileges["17"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["17"]?.access_delete === 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.title ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteMediaList({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaListId: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["17"]?.access_edit === 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditMediaList({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  const debounceRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearch(value);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (value === "" || !value) {
        return;
      }

      dispatch(
        GetMediaList({
          rowsPerPage,
          page,
          search: value, // Use latest value directly
          callback: (data) => {
            console.log({ data123123: data });
            if (data) {
              setData(data?.data);
            }
          },
        })
      );
    }, 1000);
  };

  return (
    <>
      <DynamicTable
        withNavigateToFormAndLinkIs="/media-list-media-gallery"
        handleSearch={handleSearch} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(mediaListId) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteMediaList({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaListId: mediaListId,
                    })
                  ),

                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["17"]?.access_write === 1}
        withDeleteItem={dataPrivileges["17"]?.access_delete === 1}
        withEditItem={dataPrivileges["17"]?.access_edit === 1}
        withPagination={true}
        withSearch={true}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Media List"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new media list"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onSubmit={(valuess) => {
            dispatch(
              ManageMediaList({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default MediaList;
